const DEFAULT_TTL_MS = 60 * 1000;

const stores = new Map();

const getStore = (namespace) => {
  if (!stores.has(namespace)) {
    stores.set(namespace, new Map());
  }

  return stores.get(namespace);
};

export const getCachedValue = (namespace, key) => {
  const store = getStore(namespace);
  const cached = store.get(key);

  if (!cached) {
    return null;
  }

  if (cached.expiresAt <= Date.now()) {
    store.delete(key);
    return null;
  }

  return cached.value;
};

export const setCachedValue = (namespace, key, value, ttlMs = DEFAULT_TTL_MS) => {
  const store = getStore(namespace);
  store.set(key, {
    value,
    expiresAt: Date.now() + ttlMs
  });
};

export const clearCacheNamespace = (namespace) => {
  stores.delete(namespace);
};

export const clearAllRequestCaches = () => {
  stores.clear();
};
